module.exports = __webpack_public_path__ + "static/media/rug.eb18c75e.png";